import { RootState } from '../index';

const getMembers = (state: RootState) => state.teamReducer.members;
const getIsOpenDeleteDialog = (state: RootState) => state.teamReducer.isOpenDeleteDialog;
const getSelectedMember = (state: RootState) => state.teamReducer.selectedMember;
const getIsOpenBulkDialog = (state: RootState) => state.teamReducer.isOpenBulkDialog;
const getShopifyIdToMemberMap = (state: RootState) => state.teamReducer.shopifyIdToMemberMap;
const getSelectedLocationId = (state: RootState) => state.teamReducer.selectedLocationId;
const getActiveBulkStep = (state: RootState) => state.teamReducer.activeBulkStep;
const getIsOpenShopifyIdVideo = (state: RootState) => state.teamReducer.isOpenShopifyIdVideo;

export {
  getMembers,
  getIsOpenDeleteDialog,
  getSelectedMember,
  getIsOpenBulkDialog,
  getShopifyIdToMemberMap,
  getSelectedLocationId,
  getActiveBulkStep,
  getIsOpenShopifyIdVideo,
};
